import { GlassSurface } from '@components/glass/GlassSurface';
import { PROCESS_STEPS } from '@config/content';

import styles from './ProcessSteps.module.scss';

/**
 * How an engagement runs, as a numbered sequence. An ordered list, because
 * the order is the content: the steps reveal one after another for the
 * same reason.
 */
export const ProcessSteps = () => (
  <ol className={styles.steps}>
    {PROCESS_STEPS.map((step, index) => (
      <GlassSurface as="li" key={step.title} refract={false} className={styles.step} data-reveal="">
        <span className={styles.number} aria-hidden="true">
          {String(index + 1).padStart(2, '0')}
        </span>
        <h3 className={styles.title}>{step.title}</h3>
        <p className={styles.description}>{step.description}</p>
      </GlassSurface>
    ))}
  </ol>
);
